const pt = {
  // common
  'Loading...': 'Carregando...',
  'No data': 'Nenhum dado',
  Yes: 'Sim',
  No: 'Não',
  Imperial: 'Imperial',
  Metric: 'Métrico',
  Bar: 'bar',
  bar: 'bar',
  'm^3/min': 'm^3/min',
  'm3/min': 'm<0>3</0>/min',
  kW: 'kW',
  'SPECIFIC POWER': 'POTÊNCIA ESPECÍFICA',
  pressure: 'Pressão',
  'operation mode': 'Modo de Operação',
  flow: 'vazão',
  power: 'Potência',
  PSI: 'psi',
  psi: 'psi',
  CFM: 'CFM',
  cfm: 'cfm',
  RPM: 'RPM',
  temperature: 'temperatura',
  Temperature: 'Temperatura',
  Celsius: 'Celsius',
  celsius: 'celsius',
  Fahrenheit: 'Fahrenheit',
  fahrenheit: 'fahrenheit',
  '°C': '°C',
  '°F': '°F',
  current: 'corrente',
  'Oil temperature': 'Temperatura de óleo',
  'Dew point temperature': 'Temperatura do ponto de orvalho',
  'Inverter speed': 'Velocidade do inversor',
  'Run hours': 'Horas de operação',
  'Load hours': 'Horas de carga',
  '_ _': '_ _',
  'N/A': 'N/A',
  'Water Flow': 'Vazão Hídrica',
  'Inlet Water Temperature': 'Temperatura de entrada da água',
  'Outlet Water Temperature': 'Temperatura de saída da água',

  // login page
  'Welcome to EcoPlant': 'Bem-vindos à EcoPlant',
  'For technical support email us at:': 'Para suporte técnico, envie um e-mail para:',
  'EcoPlant 2025. All right reserved.': 'EcoPlant 2025. Todos os direitos reservados.',
  'Email Address': 'Endereço de e-mail',
  Password: 'Senha',
  Login: 'Login',
  'Enter a verification code': 'Insira um código de verificação',
  'Send Again': 'Enviar novamente',
  Done: 'Pronto',
  Cancel: 'Cancelar',
  'SMS with a verification code was sent to your phone':
    'Um SMS com um código de verificação foi enviado para seu celular',
  'Forgot Password': 'Esqueci a senha',
  'Sign in with Single Sign On': 'Entrar com Login Único',

  // side menu
  "Eco plant's logo": 'Logotipo da Ecoplant',
  'Log out': 'Sair',

  // eco score card
  'ECO RATING': 'CLASSIFICAÇÃO ECO',
  'Specific power': 'Potência específica',
  'kW/(m^3/min)': 'kW/(m^3/min)',
  'kW/(m3/min)': 'kW/(m<0>3</0>/min)',
  'm^3': 'm<0>3</0>',
  'ft^3': 'ft<0>3</0>',
  'kW/100CFM': 'kW/100CFM',

  // alerts
  ALERTS: 'ALERTAS',
  All: 'Todos',
  Service: 'Serviço',
  service: 'serviço',
  Warning: 'Aviso',
  warning: 'aviso',
  Shutdown: 'Desligamento',
  shutdown: 'desligamento',
  Expired: 'Expirado',
  Custom: 'Personalizado',
  Manufacturer: 'Fabricante',
  'No more alerts to show': 'Nenhum alerta adicional para mostrar',
  'No alerts to show for this severity type.': 'Nenhum alerta para mostrar para esse tipo de gravidade.',
  RECOMMENDATION: 'RECOMENDAÇÃO',
  'No archived alerts yet.': 'Nenhum alerta arquivado ainda.',
  'Or contact us via:': 'Ou nos contate via:',
  noAlertsToShow: 'Nenhum alerta para mostrar. Você pode ver alertas antigos na <1>aba Arquivo</1>.',
  'Archive Alert': 'Arquivo de Alerta',
  'Unarchive alert failed': 'Falha ao desarquivar alerta',
  "View Alert record's rule (logic)": 'Visualizar a regra (lógica) do registro de alerta',
  'Auto & manually archived alerts': 'Alertas arquivados automática e manualmente',
  'Received during maintenance': 'Recebido durante manutenção',
  'This alert record was triggered while the compressor was In-Maintenance':
    'Este registro de alerta foi acionado enquanto o compressor estava em manutenção',
  SSOLoginNotEnabled:
    'Sua organização não habilitou o login SSO para seu endereço de e-mail. Em vez disso, use o método de autenticação de senha',
  LoginFailureNoStations:
    'Sua tentativa de login foi mal sucedida pois atualmente você não possui estações atribuídas à sua conta. Entre em contato com seu administrador de TI para solicitar acesso às estações necessárias.',
  LoginFailurePasswordError:
    'Sua tentativa de login foi mal sucedida. Erro do sistema: {{error}} Se a sua organização usa Login Único (SSO), tente logar utilizando a opção SSO.',
  LoginFailureUnhautorizedSSO:
    'Sua tentativa de login foi mal sucedida pois sua conta SSO não está autorizada. Tente logar com outra conta SSO ou use a opção de login por senha.',

  // main
  Map: 'Mapa',
  Trends: 'Tendências',
  Investigation: 'Investigação',
  'Reset zoom': 'Restaurar zoom',
  VALUE: 'valor',
  PLANT: 'planta',
  REPORTS: 'relatórios',
  ENGINE: 'motor',
  OFFERING: 'oferta',
  SETTINGS: 'configurações',

  // MapKPI
  'Value may depend on multiple sensors and average values over time.':
    'O valor pode depender de múltiplos sensores e valores médios ao longo do tempo.',
  moreDetailsInStationControl: 'Veja mais detalhes na aba Centro de Controle de Estação',
  moreDetailsInValueDashboard: 'Veja mais detalhes na tela Painel de Controle de Valores',
  'Compressor kW based calculation': 'Cálculo baseado em kW do compressor',
  'Flow based on Flow sensor avg at the end of the station':
    'Vazão baseada na média de Vazão do sensor no final da estação',
  'Pressure Drop': 'Queda de pressão',

  // Trends
  UTC: 'UTC',
  Yesterday: 'Ontem',
  'Last 24 hours': 'Últimas 24 horas',
  'Last 7 days': 'Últimos 7 dias',
  'Last 30 days': 'Últimos 30 dias',
  'Last 90 days': 'Últimos 90 dias',

  Pressure: 'Pressão',
  Flow: 'Vazão',
  Power: 'Potência',
  'Specific Power': 'Potência específica',
  'specific power': 'potência específica',
  'Oil temp': 'Temp de óleo',
  'Dew temp': 'Temp de orvalho',

  // trends - tooltip
  second: 'segundo',
  seconds: 'segundos',
  minute: 'minuto',
  minutes: 'minutos',
  hour: 'hora',
  hours: 'horas',
  day: 'dia',
  week: 'semana',
  month: 'mês',
  '{{value}} {{unit}} average': '{{value}} {{unit}} média',

  // device modal
  Run: 'Executar',
  Load: 'Carregar',
  LOAD: 'Carregar',
  Unload: 'Descarregar',
  UNLOAD: 'Descarregar',
  Off: 'Desligado',
  OFF: 'Desligado',
  ON: 'Ligado',
  On: 'Ligado',
  Loading: 'Carregando',
  Unloading: 'Descarregando',
  Disconnected: 'Desconectado',
  disconnected: 'Desconectado',
  'No State': 'Nenhum Estado',
  NoState: 'Nenhum Estado',
  NO_STATE: 'nenhum estado',
  capacity: 'capacidade',
  Liter: 'Litro',
  liter: 'litro',
  Gallon: 'Galão',
  gallon: 'galão',
  'pipe diameter': 'diâmetro da tubulação',
  'pipe material': 'material da tubulação',
  inch: 'polegada',
  mm: 'mm',
  'dew point temperature': 'temperatura do ponto de orvalho',
  activity: 'atividade',

  STOPPED: 'Parado',
  Connected: 'Conectado',
  connected: 'Conectado',
  'Not connected': 'Não conectado',
  connectivity: 'Conectividade',
  CONNECTION_ERROR: 'erro de conexão',

  Auto: 'Automático',
  Manual: 'Manual',
  Controllable: 'Controlável',
  CONTROLLABLE: 'Controlável',
  ON_OFF: 'Ligado/Desligado',
  NOTCONTROLLABLE: 'Não Controlável',
  NOT_CONTROLLABLE: 'Não Controlável',
  'On/Off': 'Ligado/Desligado',
  'Not controllable': 'Não Controlável',
  'Min set point': 'Ponto de ajuste mín',
  'Max set point': 'Ponto de ajuste máx',
  VSD_TARGET: 'Referência VSD',
  NEXT_SERVICE_IN: 'próximo serviço em',
  NEXT_SERVICE_TYPE: 'tipo de próximo serviço',
  h: 'h',
  Min: 'Min',
  WORKING_HOURS: 'horas de trabalho',
  HORSE_POWER: 'cavalo-vapor',
  'control mode': 'Modo de Controle',

  'filter type': 'tipo de filtro',
  'last service': 'último serviço',
  CYCLE: 'CICLO',
  DUTY: 'CAPACIDADE',
  'Sensor Based': 'Baseada em Sensor',
  'Compressor Estimation': 'Estimativa do Compressor',
  'kW Based Calculation': 'Cálculo Baseado em kW',
  'AI Calculation': 'Cálculo IA',
  'RELATIVE POSITION': 'POSIÇÃO RELATIVA',
  'back indication': 'indicação de reversão',
  'last command': 'último comando',
  'default state': 'estado padrão',
  Open: 'Abrir',
  'Last set point': 'Último ponto de ajuste',
  'I/O': 'E/S',
  'relative position': 'Posição Relativa',
  pressureSetpoints: 'Pontos de Ajuste de Pressão',
  hp: 'HP',
  lp: 'LP',
  lowLimit: 'Limite Inferior',
  targetSetpoint: 'Ponto de ajuste Alvo',

  // node factory
  Filter: 'Filtro',
  Valve: 'Válvula',
  INLET_VALVE: 'válvula de entrada',
  BYPASS_VALVE: 'válvula de desvio',
  CLOSE: 'fechar',
  OPEN: 'abrir',
  'Closed Valve - Connected': 'Válvula Fechada - Conectado',
  'Open Valve - Connected': 'Válvula Aberta - Conectado',
  'Valve state not found': 'Estado da válvula não encontrado',
  'Valve - Disconnected': 'Válvula - Desconectado',
  Booster: 'Booster',
  Compressor: 'Compressor',
  HP: 'HP',

  'Desiccant Air Dryer': 'Secador de Ar Dessecante',
  Desiccant: 'Dessecante',
  drying: 'Secagem',
  refrigerating: 'Refrigeração',
  waterPressureSensor: 'Sensor de Pressão Hídrica',
  'dew point': 'Ponto de Orvalho',
  DEW_POINT: 'ponto de orvalho',
  timer: 'Cronômetro',
  energySaving: 'economia de energia',
  ENERGY_SAVINGS: 'economias de energia',
  'Dew Point Sensor': 'Sensor do Ponto de Orvalho',
  'Dry Air Tank': 'Tanque de Ar Seco',
  Dry: 'Seco',
  'Dry tank': 'Tanque Seco',
  'Combo Sensor': 'Combo Sensor',
  'Flow Sensor': 'Sensor de Vazão',
  'Pressure Sensor': 'Sensor de Pressão',
  'Production Floor': 'Chão de fábrica',
  'Refrigerated Air Dryer': 'Secador de Ar Refrigerado',
  Refrigerated: 'Refrigerado',
  'Wet Air Tank': 'Tanque de Ar Úmido',
  Wet: 'Úmido',
  Maintenance: 'Manutenção',

  fixedSpeed: 'Compressor de Velocidade Fixa',
  variableSpeedDrive: 'Compressor de Velocidade Variável',
  centrifugal: 'Compressor Centrífugo',
  fixedSpeed_powerSensor: '$t(Velocidadefixa)',
  powerSensor_variableSpeedDrive: '$t(inversordeFrequência)',
  centrifugal_powerSensor: '$t(centrífugo)',
  booster: '$t(Booster)',
  wetAirTank: '$t(Tanque de Ar Úmido)',
  dryAirTank: '$t(Tanque de Ar Seco)',
  desiccantAirDryer: '$t(Secador de Ar Dessecante)',
  refrigeratedAirDryer: '$t(Secador de Ar Refrigerado)',
  pressureSensor: '$t(Sensor de Pressão)',
  flowSensor: '$t(Sensor de Vazão)',
  flowSensor_pressureSensor: 'Sensor de Pressão e Vazão',
  dewpointSensor: '$t(Sensor do Ponto de Orvalho)',
  dewpointSensor_pressureSensor: 'Sensor de Pressão e Ponto de Orvalho',
  ambientHumiditySensor_ambientTemperatureSensor: 'Sensor de Temperatura e Umidade Ambiente',
  ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor:
    'Sensor do Ponto de Orvalho, Temperatura e Umidade Ambiente',
  airTemperatureSensor: '$t(SENSOR_TEMPERATURA_AR)',
  airFilter: '$t(Filtro)',
  proportionalValve: 'Válvula Proporcional',
  openCloseValve: 'Válvula Abrir/Fechar',
  spillValve: 'Válvula de Alívio',
  productionFloor: '$t(Chão de Fábrica)',

  // alert rules
  'The logic triggering alerts': 'A lógica que aciona os alertas',
  'Alert rules management': 'Gerenciamento das regras de alerta',
  'My rules': 'Minhas regras',
  'No rules to display': 'Sem regras para exibir',
  'Rule condition:': 'Condição da regra:',
  and: 'e',
  or: 'ou',
  of: 'de',
  is: 'é',
  greaterThan: 'maior que',
  equalTo: 'igual a',
  notEqualTo: 'diferente de',
  greaterThanOrEqualTo: 'maior que ou igual a',
  lessThan: 'menor que',
  lessThanOrEqualTo: 'menor que ou igual a',
  'Filter by source': 'Filtrar por fonte',
  'Filter by device': 'Filtrar por dispositivo',
  'Create new rule': 'Criar nova regra',
  'Rule activation status': 'Status de ativação de regra',
  Severity: 'Gravidade',
  'Date created': 'Data de criação',
  'Last updated': 'Última atualização',
  'Are you sure you want to start monitoring and alerting on this type of events?':
    'Tem certeza que deseja começar o monitoramento e alerta nestes tipos de eventos?',
  'Are you sure you want to stop monitoring and alerting on this type of events?':
    'Tem certeza que deseja parar o monitoramento e alerta nestes tipos de eventos?',
  'Failed to change activation status': 'Falha ao alterar o status de ativação',
  'Are you sure you want to delete this rule?': 'Tem certeza que deseja excluir esta regra?',
  'Failed to delete rule': 'Falha ao excluir regra',
  'This alert rule has changed since the record you clicked on. The last change was on':
    'Esta regra de alerta foi alterada desde o registro que você clicou. A última alteração foi em',
  'This alert rule has been deleted': 'A regra de alerta foi excluída',
  'You can only turn this alert rule off.': 'Você só pode desativar esta regra de alerta.',
  'To modify please contact your system administrator or the Ecoplant support':
    'Para modificar, entre em contato com seu administrador de sistema ou com o suporte da Ecoplant',
  'New Alert': 'Novo Alerta',

  // create edit rule
  Update: 'Atualizar',
  Create: 'Criar',
  'Create and Activate': 'Criar e Ativar',
  'Update a custom rule': 'Atualizar uma regra personalizada',
  'Create a custom rule': 'Criar uma regra personalizada',
  'Name the alerts and set their severity.': 'Nomeie os alertas e defina suas gravidades.',
  'Define the logic for triggering alerts of different severity levels.':
    'Defina a lógica para acionar alertas de diferentes níveis de gravidade.',
  'E.g. High than usual flow causes pressure drop': 'Ex. Vazão maior que a normal causa queda de pressão',
  Description: 'Descrição',
  'E.g. Try do the following...': 'Ex. Tente fazer o seguinte...',
  'Alert severity': 'Alerta de gravidade',
  'Rule name (Title)': 'Nome da regra (Título)',
  'Duration (if this rule lasts for x time)': 'Duração (se esta regra dura por tempo x)',
  Immediately: 'Imediatamente',
  'Choose the parameter you wish to monitor.': 'Escolha o parâmetro que deseja monitorar.',
  Parameter: 'Parâmetro',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'Escolha um dispositivo com o parâmetro monitorado selecionado acima. Selecione múltiplos dispositivos para criar uma regra para o parâmetro calculado (ex.: diferença de pressão entre os dispositivos).',
  'Choose the operand and the target value threshold to trigger the alerts.':
    'Escolha o operando e o valor limite de referência para acionar os alertas.',
  Operand: 'Operando',
  'Target value': 'Valor de referência',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.':
    'Salve e ative para começar a monitorar o parâmetro e acionar o alerta de acordo com a regra.',
  'Contact us if you have any questions at:': 'Em caso de dúvidas, entre em contato através de:',
  'Add device': 'Adicionar dispositivo',
  'E.g. 6.4': 'Ex. 6.4',
  'Alert rule updated successfully': 'Regra de alerta atualizada com sucesso',
  'Alert rule created successfully': 'Regra de alerta criada com sucesso',
  'Follow the math order of operations.': 'Siga a ordem das operações matemáticas.',
  'You dont have enough permission to create an alert, please contact your administrator.':
    'Você não tem permissão suficiente para criar um alerta, entre em contato com seu administrador.',
  'Update manufacturer alert rule': 'Atualizar regra de alerta do fabricante',
  'Edit this Alert rule appearance': 'Editar a aparência desta regra de Alerta',
  'Alert rule original details': 'Detalhes originais da regra de alerta',
  'Original rule name (Title)': 'Nome da regra original (Título)',
  'Given rule name (Title)': 'Nome fornecido para a regra (Título)',
  'E.g. High then usual flow causes pressure drop': 'Ex. Vazão mais alta que o normal causa queda de pressão',
  'Original description': 'Descrição original',
  'Given description': 'Descrição fornecida',
  'Device name': 'Nome do dispositivo',
  'Alert rule ID': 'ID da regra de alerta',
  'Creation date': 'Data de criação',

  //error modal
  'Something went wrong': 'Algo deu errado',
  'Please try again later.': 'Tente novamente mais tarde.',
  Dismiss: 'Dispensar',

  //Proactive engine (dynamic controller)
  'Dynamic Controller': 'Controlador Dinâmico',
  'Controller Mode': 'Modo Controlador',
  Activated: 'Ativado',
  Deactivated: 'Desativado',
  Unavailable: 'Indisponível',
  Unknown: 'Desconhecido',
  'Dynamic Controller is Activated': 'Controlador Dinâmico está Ativado',
  'Dynamic Controller is Deactivated': 'Controlador Dinâmico está Desativado',
  'Dynamic Controller is Disabled - Under Maintenance': 'Controlador Dinâmico está Desabilitado - Sob Manutenção',
  'Dynamic Controller is Disabled by Local Control Switch':
    'Controlador Dinâmico está Desabilitado pelo Interruptor de Controle Local',
  'Dynamic Controller is Disabled by Cloud Control Switch':
    'Controlador Dinâmico está Desabilitado pelo Interruptor de Controle da Nuvem',
  leakMeasurementNear: 'Medição de Vazamento em uma semana',
  leakMeasurementOnGoing: 'Medição de Vazamento está em andamento',
  leakMeasurementInDays: 'Medição de Vazamento agendada em {{count}} dias',
  'Are you sure?': 'Tem certeza?',
  measuredLeak: 'Mesuré',
  leakMeasureFlow: '% Vazão',
  leakProductionFlow: '% prod. fluxo',
  leakageCreatedNotificationMessage: 'Avisa quando um novo evento de vazamento é criado',
  FailedToActivateDynamicController: 'Falha ao ativar o controlador dinâmico',
  FailedToDeactivateDynamicController: 'Falha ao desativar o controlador dinâmico',
  CompressorInMaintenancePreventsActivation:
    'O Controlador Dinâmico não pode ser ativado porque os compressores estão em manutenção ou com a prioridade definida como Ignorada.',

  // No Flow Control Notification Modal
  noFlowControlNotificationTitle: 'O Controle Dinâmico para esta estação foi atualizado.',
  noFlowControlNotificationSubtitle:
    'Agora estamos usando fluxo estimado ("sem fluxo") em vez do controle por sensor de fluxo. Como resultado:',
  noFlowControlKpisRecalculated:
    'Os KPIs de Fluxo e Potência Específica são recalculados, então os valores podem mudar.',
  noFlowControlSavingsAdjusted: 'As economias são ajustadas usando a mesma potência específica de referência.',
  noFlowControlSensorsDifferent:
    'Os sensores de fluxo ainda mostram leituras, mas não afetam mais os KPIs e aparecem de forma diferente no mapa.',
  noFlowControlHistoricalKpis: 'Os KPIs históricos do sensor de fluxo permanecem disponíveis até a mudança.',
  noFlowControlClosingMessage:
    'Esta atualização ajuda a garantir controle suave e desempenho consistente. Aproveite a atualização!',
  noFlowControlOkButton: 'OK, entendi!',

  'Last commands': 'Últimos comandos',
  Device: 'Dispositivo',
  'New Value': 'Novo Valor',
  User: 'Usuário',
  Status: 'Status',
  Reason: 'Motivo',
  'Date Created': 'Data de criação',
  'No commands to show': 'Nenhum comando para mostrar',
  'Load more': 'Carregar mais',
  'Waiting For Deliver': 'Aguardando Para Entregar',
  'Received And Updated': 'Recebido E Atualizado',
  'Failed To Update': 'Falha Ao Atualizar',
  'Failed TimeOut': 'Falha de Tempo Excedido',
  'Failed Offline': 'Falha Offline',
  'Ignored Unchanged Value': 'Valor Não Alterado Ignorado',

  //Investigation dashboard
  'Investigate by Devices': 'Investigar por Dispositivos',
  'Show me (from-to)': 'Mostrar-me (de-para)',
  'Compare with (Show me from-to)': 'Comparar com (Mostrar-me de-para)',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    'Você pode escolher até 10 parâmetros por período de tempo. Ao comparar 2 períodos de tempo, você pode escolher até 5 parâmetros.',
  'When comparing 2 time periods, you can choose up to 5 parameters.':
    'Ao comparar 2 períodos de tempo, você pode escolher até 5 parâmetros.',
  'Choose only Power parameters to view the Stack layout. You cannot choose the station total power':
    'Escolha apenas parâmetros de Potência para visualizar o Stack layout. Você não pode escolher a potência total da estação',
  'Station KPIs': 'KPIs da estação',
  'Periods compare': 'Comparação de períodos',
  'Pressure drop': 'Queda de pressão',
  'Please choose a time period and at least one parameter.': 'Escolha um período de tempo e pelo menos um parâmetro.',
  'No data to show for this time frame and parameters.':
    'Sem dados para exibir para este período de tempo e parâmetros.',
  'Please choose at least one graph.': 'Escolha pelo menos um gráfico.',
  'Left mouse to zoom': 'Clique com o botão esquerdo do mouse para dar zoom',
  'Alt + Left mouse to pan': 'Alt + Clique com o botão esquerdo do mouse para mover',
  minuteAverageWithCount: '{{count}} minuto em média',
  minuteAverageWithCount_plural: '{{count}} minutos em média',
  hourAverageWithCount: '{{count}} hora em média',
  hourAverageWithCount_plural: '{{count}} horas em média',
  'Sensor based': 'Baseada em sensor',
  'Comp. Est.': 'Comp. Est.',
  'kW Calc. Based': 'Calc. kW Baseado',
  'AI Calc.': 'Calc. IA',
  'kW based calculation': 'Cálculo baseado em kW',
  Tabular: 'Tabular',
  'Alerts Record List': 'Lista de Registro de Alertas',
  'Alert Record': 'Registro de Alerta',
  Source: 'Fonte',
  'Date Fired': 'Data de Ativação',
  'Displayed alerts': 'Alertas exibidos',
  Archived: 'Arquivado',
  'Time period': 'Período de tempo',
  restAlerts: '...e {{restAlertsCount}} mais alertas',
  total: 'Total',
  compareTwoTimePeriods: 'Comparar 2 períodos de tempo',
  none: 'Nenhum',
  showInDeviceStatus: 'Mostrar no status do dispositivo',
  maintenance: 'Manutenção',
  'n/a': 'N/A',
  devicesStatus: 'Status dos Dispositivos',
  dynamicControl: 'Controle Dinâmico',
  optimize: 'OTIMIZAR',
  now: 'Agora',

  //Data export
  'Report export': 'Exportação de relatório',
  'Report export preferences': 'Preferências de exportação de relatório',
  'This file will be downloaded as a .csv': 'Este arquivo será baixado como um .csv',
  'Time presentation interval': 'Intervalo de apresentação de tempo',
  'Time zone': 'Fuso horário',
  'Unit system': 'Sistema de unidades',
  Export: 'Exportar',
  'Report contains to many records': 'O relatório contém muitos registros',
  'Another export is already in progress': 'Outra exportação já está em andamento',
  VS: 'VS',
  'Data export failed': 'Falha ao exportar dados',
  'While your file is being prepared do not refresh or close this tab':
    'Enquanto seu arquivo está sendo preparado não atualize ou feche esta aba',
  'Something went wrong. Make sure you generated a valid report in the investigation tab':
    'Algo deu errado. Certifique-se de ter gerado um relatório válido na aba de investigação',

  //Station control center
  'Station Control Center': 'Centro de Controle de Estação',
  TARGET: 'REFERÊNCIA',
  MAINTENANCE: 'MANUTENÇÃO',
  OPERATION: 'OPERAÇÃO',
  'Failed changing maintenance mode': 'Falha ao alterar o modo de manutenção',
  SCC: 'CCE',
  'You are about to modify the control of the dynamic controller. Are you sure?':
    'Você está prestes a modificar o controle do controlador dinâmico. Tem certeza?',
  setpointsSetTo: 'Os pontos de ajuste serão definidos para: ',
  noneSetpoints: 'Últimos pontos de ajuste configurados',
  baselineSetpoints: 'Pontos de ajuste base',
  customSetpoints: 'Personalizar Pontos de ajuste',
  contactCustomerSuccessManager:
    'Entre em contato com seu Gestor de Sucesso do Cliente para alterar este comportamento',

  /// Power toggle tooltips
  'Changes can be made in Station Control Center only.':
    'Alterações podem ser feitas apenas no Centro de Controle da Estação.',
  'Turn compressor on verification': 'Você está prestes a ligar {{name}}. Tem certeza?',
  'Turn compressor off verification': 'Você está prestes a desligar {{name}}. Tem certeza?',
  'Function is disabled since Engine Mode is Activated': 'A função está desabilitada pois o Modo do Motor está Ativado',
  'Function is disabled since changing power state is not supported on this compressor.':
    'A função está desabilitada pois a alteração de estado de potência não é suportado neste compressor.',
  'Waiting for state to change.': 'Aguardando o estado para alterar.',
  'You are not allowed to change power state for devices.':
    'Você não tem permissão para alterar o estado de potência dos dispositivos.',
  'Are you sure you want to mark this device as In maintenance?':
    'Tem certeza que deseja marcar este dispositivo como Em manutenção?',
  'Are you sure you want to mark this device as not in maintenance?':
    'Tem certeza que deseja marcar este dispositivo como não em manutenção?',
  goingToMaintenanceMessage:
    'Definir todos os compressores em manutenção irá desativar o controle dinâmico. Tem certeza?',
  CHANGE_COMPRESSOR_STATE_FAILED: 'Falha ao alterar estado {{deviceName}} de potência do compressor',
  Start: 'Iniciar',
  Stop: 'Parar',

  //P&ID Draft
  'P&ID Draft': 'Rascunho de P&ID',
  'Last updated on:': 'Última atualização em:',
  'Refresh Map': 'Atualizar Mapa',
  'Station Draft': 'Rascunho da Estação',

  //Value Dashboard
  SHOWING_CURRENT_MONTH_ACCUMULATED_DATA: 'Mostrando dados acumulados do mês atual',
  Energy: 'Energia',
  Volume: 'Volume',
  'Energy Efficiency': 'Eficiência Energética',
  'Energy Saving': 'Economia de Energia',
  Baseline: 'Base',
  'Actual Energy': 'Energia Atual',
  'Specific Power Baseline': 'Base para Potência Específica',
  'Maintenance Event': 'Evento de Manutenção',
  'Baseline Period From': 'Período de Base De',
  To: 'A',
  DAY: 'DIA',
  MTD: 'MTD',
  YTD: 'YTD',
  YEAR: 'ANO',
  MONTH: 'MÊS',
  AVG: 'MÉD',
  MT: 'MT',
  GHG: 'GEE',
  energySavingsOpportunity: 'Oportunidades de Economias de Energia',
  'MONTH AVG': 'MÉDIA MÊS',
  'YEAR TOTAL': 'TOTAL ANO',
  '5-YEAR PROJECTION REDUCTION': 'PROJEÇÃO DE REDUÇÃO EM 5 ANOS',
  // Leakage
  leakage: 'Vazamento',
  overview: 'Visão geral',
  segmentation: 'Segmentação',
  timeline: 'Registro de Medição',
  // Overview tab
  lastLeakageMeasure: 'MEDIÇÃO DO ÚLTIMO VAZAMENTO',
  previous: 'Anterior',
  lifetime: 'DURAÇÃO',
  lifeTimeLocalization: 'Duração',
  actionTaken: 'Ação Tomada',
  wasted: 'Desperdiçado',
  lastMeasureDate: 'Última medição de vazamento',
  nextPeriodicShutdown: 'Próximo desligamento',
  add: 'Adicionar',
  setAnAudit: 'Definir um período de auditoria',
  dailyFlowTooltip: 'Vazão média diária do mês anterior',
  kwLeakRateSliderTooltip: 'Consumo de energia estimado no último desligamento periódico',
  ytdTooltip: 'Os dados são atualizados mensalmente',
  ok: 'OK',
  clear: 'Limpar',
  nextPeriodicShutdownPopconfirm1:
    'Um rascunho de período de Vazamento foi criado. Será exibido aqui apenas após aprovação do especialista da Ecoplant.',
  nextPeriodicShutdownPopconfirm2:
    'Certifique-se de manter os compressores ligados por pelo menos 2 horas para que o sistema capture potenciais vazamentos.',
  startEnd: 'Início - Fim',
  productionLeakRate: 'Taxa de Prod. Vazamento',
  addNextPeriodicShutdown: 'Adicionar rascunho do próximo período de vazamento',
  confirmDeleting: 'Excluir Período de Desligamento para períodos {{period}}',
  delete: 'Excluir',
  excludeFuturePeriodicShutdowns: 'Excluir futuros períodos de desligamento',
  leakFlow: 'Vazamento',
  estimatedLeakTooltip: 'Vazamento Estimado ({{estimatedLeak}}',
  sampledFlowDuringShutdownTooltip: 'Vazão amostrada durante Desligamento ({{sampledFlowDuringShutdown}}',
  productionLeakRateTooltip:
    'Calculada ao normalizar a vazão de vazamento para a pressão de referência e dividir pela média da vazão de produção ({{productionLeakRate}}',
  overlappingDates: 'Sobrepor datas não é válido',
  updateLeakAudit: 'Atualizar auditoria de vazamento',
  updateAudit: 'Atualizar auditoria',
  leakAuditUpdatedSuccessfully: 'Auditoria de vazamento atualizada com sucesso',
  theAuditDatesHaveBeenUpdated: 'As datas da auditoria foram atualizadas',
  leakAuditUpdatedAndPublishedSuccessfully: 'Rascunho de vazamento foi publicado para o cliente',
  errorUpdatingLeakAudit: 'Erro ao atualizar a auditoria de vazamento',
  leakAuditRejectedSuccessfully: 'Auditoria de vazamento rejeitada com sucesso',
  errorRejectingLeakAudit: 'Erro ao rejeitar a auditoria de vazamento',
  leakAuditBookedSuccessfully: 'Auditoria de vazamento agendada com sucesso',
  scheduleLeakAudit: 'Agendar auditoria de vazamento',
  setAudit: 'Definir auditoria',
  reviewLeakAudit: 'Revisar auditoria de vazamento',
  rejectAudit: 'Rejeitar auditoria',
  updateAndPublish: 'Atualizar e publicar',
  viewLeak: 'Ver vazamento',
  // MeasurementSegmentation tab
  totalWasteFlow: 'Vazão de Desperdício Total',
  totalProductionFlow: 'Vazão de Produção Total',
  productionLine: '{{productionLineName}} Linha',
  totalPlant: 'Planta Total',
  production: 'Produção',
  waste: 'Desperdício',
  flowLabel: 'Vazão',
  effective: 'Efetiva',

  // Insights
  insights: 'Insights',
  events: 'Eventos',
  // Overview tab
  ytdValue: 'VALOR YTD',
  lifetimeValue: 'VALOR DE VIDA ÚTIL',
  savingsOpportunity: 'OPORTUNIDADE DE ECONOMIAS',
  saved: 'SALVO',
  actionsPending: 'Ações Pendentes',
  actionsTaken: 'Ações Tomadas',
  rejected: 'rejeitado',
  Risk: 'Risco',
  // Events tab
  pendingTasksOnly: 'Apenas Tarefas Pendentes',
  dateOpened: 'Data de Abertura',
  insightName: 'Nome do Insight',
  asset: 'Ativo',
  valueType: 'Tipo de Valor',
  value: 'Valor {{currency}}',
  dateCompleted: 'Data de Conclusão',
  InProgress: 'Em Andamento',
  Reject: 'Rejeitar',
  estimatedDeliveredValue: 'Valor Entregue Estimado',

  // Engine
  wizard: 'Assistente',
  draft: 'Rascunho',
  newDraft: 'Novo Rascunho',
  createNewDraft: 'Criar um Novo Rascunho',
  published: 'Publicado',
  recommended: 'Recomendado',
  publishDraftConfirmation:
    'Tem certeza que deseja publicar todas as alterações realizadas em todas as abas de configuração?',
  publishRecommendationConfirmation:
    'Esta versão será diretamente publicada para produção{{draftVersionText}}. Deseja continuar?',
  draftVersionText: ' e substituir a versão de rascunho existente {{draftVersion}}',
  newRecommendedConfiguration:
    'Uma nova versão do controlador dinâmico está disponível. Data de criação: {{createdDate}}',
  'publishConfirmationEngine1.0':
    'Esta estação é administrada pelo Controlador Dinâmico versão 1.0. Para atualizar para a versão 1.5, vá para ReTool e altere a versão do Motor para 1.5. Assim que fizer isso, essa versão publicada irá administrar a estação.',
  revertToPublishedConfirmation: 'Tem certeza que deseja substituir as configurações com as publicadas atualmente?',
  missingMandatoryFieldValue:
    'Campo editável = "{{field}}" do compressor = "{{compressor}}" da tabela = "{{table}}" precisa de um valor de entrada válido.',
  recommendationFlowLevelsChanged:
    'Os níveis de fluxo ou os intervalos de pressão foram modificados, portanto as regras de fallback existentes não são mais válidas e foram removidas.',
  revertToPublished: 'Reverter para Publicado',
  publish: 'Publicar',
  settings: 'Configurações',
  next: 'Próximo',
  back: 'Voltar',
  finish: 'Concluir',
  cancel: 'Cancelar',
  defaults: 'Padrões',
  noDynamicController: 'O Controlador Dinâmico não foi definido.',
  // Recommendation
  createdOn: 'Criado em: ',
  approvalReport: 'Relatório de Aprovação',
  // Rules Generator
  mainRanges: 'Faixas Principais',
  mainRangesConfiguration: 'Configuração de Vazão e Pressão',
  rulesGenerator: 'Gerador de Regras',
  flowLevels: 'NÍVEIS DE VAZÃO',
  'Flow Levels': 'Níveis de Vazão',
  pressureLevels: 'FAIXAS DE PRESSÃO',
  result: 'RESULTADO',
  rules: 'Regras',
  // Flow Levels
  units: 'Unidades',
  name: 'Nome',
  lowerBoundFlow: 'Vazão do Limite Inferior',
  upperBoundFlow: 'Vazão do Limite Superior',
  addRangeName: 'Adicionar nome de faixa',
  addUpperRange: 'Adicionar faixa superior',
  addLevel: 'Adicionar Nível',
  addPressureRange: 'Adicionar Faixa de Pressão',
  infinity: 'Infinito',
  flowLevelsChanged:
    'Faixas de valor do sensor foram modificadas, altere os valores da tabela de regra de acordo e salve os útlimos valores',
  changesInMainRangesAffectFallbackRules:
    'Alterações nas faixas principais causam alterações nas regras de contingência. Tem certeza que deseja continuar?',
  // Pressure Levels
  range: 'Faixa',
  id: 'Id',
  lowerBoundPressure: 'Pressão do Limite Inferior',
  upperBoundPressure: 'Pressão do Limite Superior',
  thisPressureLevel: 'este nível de pressão',
  // Result
  mainRangesResult: 'RESULTADO',
  flowLevel: 'Nível de Vazão',
  rule: 'Regra',
  // Sensors
  sensors: 'Sensores',
  sensorsSelection: 'Configuração de KPI',
  sensorsConfiguration: 'Configuração de Sensores',
  flowSensorsPriority: 'SELEÇÃO DE SENSORES DE VAZÃO',
  pressureSensorsPriority: 'SELEÇÃO DE SENSORES DE PRESSÃO',
  sensorsPriorityResult: 'RESULTADO',
  main: 'Principal',
  fallback: 'Contingência {{priority}}',
  fallbacks: 'Contingências',
  logic: 'Lógica',
  online: 'Online',
  any: 'Qualquer',
  all: 'Todos',
  average: 'Média',
  minimum: 'Mínimo',
  maximum: 'Máximo',
  sum: 'Soma',
  addFallback: 'Adicionar Contingência',
  defaultBehaviour: 'Comportamento padrão',
  chooseRule: 'Escolher Regra',
  customRule: 'Personalizar Regra',
  turnOffEngine: 'Desligar motor',
  ruleGenerator: 'Gerador de Regra',
  newRuleName: 'NOME DA NOVA REGRA',
  // Result
  flowSensorsSelection: 'Seleção de Sensores de Vazão',
  pressureSensorsSelection: 'Seleção de Sensores de Pressão',
  // Compressors
  compressors: 'Compressores',
  compressorGroups: 'Grupos de Compressores',
  rotation: 'Rotação',
  on: 'Ligado',
  off: 'Desligado',
  repeatEvery: 'Repetir a cada',
  repeatOn: 'Repetir em',
  time: 'Tempo',
  weeks: 'semanas',
  addCompressorGroup: 'Adicionar um novo Grupo Compressor',
  deletePopconfirmTitle: 'Você está prestes a excluir {{item}}. Tem certeza?',
  // Default Rule
  defaultRule: 'Regra Padrão',
  defaultSetpoints: 'Padrões da Tabela',
  defaultSetpointsConfiguration: 'Padrões da Tabela',
  groupAndPriority: 'Grupo | Prioridade',
  order: 'Ordem',
  load: 'Carregar',
  unload: 'Descarregar',
  autoStop: 'Parada Automática',
  immediateStop: 'Parada Imediata',
  pressureDrop: 'Queda de pressão',
  vsdTarget: 'Referência',
  modulate: 'Modular',
  bandConfiguration: 'Configuração de Banda',
  defaultSetpointsInfoMessage:
    'Os pontos de ajuste estão baseados nas leituras de pressão da linha do compressor (quedas de pressão da conta)',
  setpointsLoadUnloadValidation: 'O ponto de ajuste de Descarga deve ser superior ao ponto de ajuste de Carga.',
  pidChanges: `A new engine strategy must be defined and published since the station P&ID has changed.
Below is the list of assets  that affect the control strategy:`,
  compressorsAdded: 'Compressores adicionados:',
  compressorsRemoved: 'Compressores removidos:',
  flowKPIModified: 'KPI de vazão modificado:',
  pressureKPIModified: 'KPI de pressão modificado:',
  compressorPriorityChangedToIgnore: 'A prioridade do compressor foi alterada de (Ativo/Backup) para Ignorar:',
  compressorPriorityChangedFromIgnore: 'A prioridade do compressor foi alterada de Ignorar para (Ativo/Backup):',

  // Station Parameters
  stationParameters: 'Parâmetros da Estação',
  compressorParameters: 'Parâmetros do Compressor',

  //package care
  careAgrremntID: 'ID do Acordo',
  annugalHoursCoverage: 'Cobertura de Horas Anuais ',
  startDate: 'Data de Início',
  expirationDate: 'Data de Expiração',
  packageCare: 'PackageCARE',
  packageCareStatus: 'Status do PackageCARE',
  inactive: 'Inativo',
  invalidDate: 'Data Inválida',
  package: 'Pacote',
  planned: 'Planejado',
  parts: 'Partes',
  care: 'CARE',
  careServiceSignUp: 'Cadastre-se para o plano de serviço CARE',
  noCareProgram: 'Nenhum Programa Care',
  thankInterestCare: 'Agradecemos seu interesse no CARE!',
  noCarePlan: 'Nenhum Plano CARE',
  activeAsset: 'está ativado para este ativo',
  tm: 'TM',
  // Fallback Scenarios
  fallbackScenarios: 'CENÁRIOS DE CONTINGÊNCIA',
  addScenario: 'Adicionar Cenário',
  onFailureOf: 'Em caso de falha de',
  singleRuleForAllFlowLevels: 'Regra Única para todos os Níveis de Vazão',
  logicPerFlowLevel: 'Lógica por Nível de Vazão',
  // Validations
  flowRanges: 'Faixas de Vazão',
  pressureRanges: 'Faixas de Pressão',
  rangesAreMandatory: '$t({{ranges}}) são obrigatórios',
  compressorsAreMandatory: 'Compressores são obrigatórios',
  higherUpperBound: 'Deve ser maior que o Limite Superior anterior',
  mustBeEqualOrHigherThan1: 'Deve ser igual ou maior do que 1',
  compressorsCombinationMustBeUnique: 'A combinação de compressores deve ser única',
  compressorIsNotCompatibleToGroup: 'Todos os compressores adicionados aos grupos devem ter as mesmas ações',
  compressorsMustHaveSameHp: 'Os compressores devem ter a mesma potência HP',
  oneFallbackOptionShouldBeSelected: 'Uma opção de contingência deve ser selecionada',
  oneRuleShouldBeSelected: 'Uma regra deve ser selecionada',
  sensorsAreMandatory: 'Sensores são obrigatórios',
  sensorFlowCombinationMustBeUnique: 'A combinação de configuração de Sensor de Vazão deve ser única',
  // Rules
  rulesOverview: 'Regras',
  rulesEditor: 'Editor de Regras',
  // Rules Overview
  no: 'Não',
  ord: 'ORD',
  lo: 'BAIXO',
  un: 'DESC',
  target: 'REF',
  mod: 'MOD',
  aut: 'AUT',
  imm: 'IMD',
  pd: 'PD',
  bnd: 'LIM',
  // new fallback columns
  compressorNumber: 'Número do Compressor',
  titleOrder: 'ORD',
  titleLoad: 'BAIXO',
  titleUnload: 'DESC',
  titleTarget: 'REF',
  titleModulate: 'MOD',
  titleAutoStop: 'AUT',
  titleImmediateStop: 'IMD',
  titlePressureDrop: 'PD',
  titleBandConfiguration: 'LIM',
  // Rules Editor
  standalone: 'Autônomo',
  viewMode: 'Visualizar Modo',
  editMode: 'Editar Modo',
  save: 'Salvar',
  discard: 'Sim (descartar)',
  keepEditing: 'Não (continuar editando)',
  // Fallback Overview
  fallbackOverview: 'Contingência',
  sensorsLogic: 'Lógica de Sensores',
  compressorsGroupOrder: 'Ordem do Grupo de Compressores',
  compressorsFallback: 'Contingência de Compressores',
  flowSensorsFallback: 'Contingência de Sensores de Vazão',
  pressureSensorsFallback: 'Contingência de Sensores de Pressão',
  sensorPriorityInfoMessage: 'Em caso de falha, a seguinte lógica será executada',
  editScenarios: 'Editar Cenários',
  // Version History
  versionHistory: 'Histórico de Versão',
  lastUpdated: 'Última atualização',
  version: 'Versão',
  changes: 'Alterações',
  revertPublishedVersion:
    'Ao reverter para a versão anterior, uma nova estratégia será publicada e substituirá o rascunho existente. Deseja continuar?',
  actions: 'Ações',
  recommendation: 'Recomendado',
  algo: 'Algo',
  manual: 'Manual',

  // station risk
  Low: 'Baixo',
  Moderate: 'Moderado',
  High: 'Alto',
  SYSTEM_AVAILABILITY: 'disponibilidade do sistema',
  REALTIME_SYSTEM_CAPACITY: 'capacidade do sistema em tempo real',
  'System Health': 'Saúde do Sistema',
  'System Degradation': 'Degradação do Sistema',
  'System Single Point of Failure Risk': 'Risco de Ponto Único de Falha do Sistema',
  'Available flow subtitle': 'Disponível',
  'Peak production subtitle': 'Produção de Pico',
  'Month Over Month avg Flow Trend': 'Tendência Média de Vazão Mês a Mês',
  'peak production delta increase part1': 'Sua produção de ar comprimido mês a mês aumentou ',
  'peak production delta increase part2':
    ' refletindo crescimento na produção ou um possível aumento de vazamento no crescimento',
  'available delta decrease part1': 'Sua capacidade de produção mês a mês reflete um desempenho reduzido de ',
  'available delta decrease part2': '. Verifique seus compressores para manutenção e operação degradada.',
  'realtime flow over peak error':
    'Erro - Valor de tempo real {{realtime}} está acima do pico de vazão {{peakSupplyFlow}}. Entre em contato com o suporte Ecoplant',
  'realtime flow over total flow error':
    'Valor de tempo real {{realtime}} está acima da vazão total da estação {{totalFlow}}.',
  'realtime flow over max available flow error':
    'Valor de tempo real {{realtime}} está acima da vazão máxima disponível {{totalFlow}}.',
  'Station risk degradation tooltip text':
    'Degradação operacional do sistema e de cada compressor em relação à sua especificação nominal.',
  'Realtime Production': 'Produção em Tempo Real',
  'Peak Production': 'Produção de Pico',
  PEAK_PRODUCTION: 'produção de pico',
  'Avg Production': 'Produção Média',
  AVG_PRODUCTION: 'produção média',
  'Max Available': 'Máximo Disponível',
  Degradation: 'Degradação',
  MODERATE_RISK: 'risco moderado',
  LOW_RISK: 'risco baixo',
  STATION_DEGRADATION: 'degradação da estação',
  PLANNED_AVAILABILITY: 'disponibilidade planejada',
  CURRENT_YEAR: 'ANO ATUAL',
  PREVIOUS_YEAR: 'ANO ANTERIOR',

  // users management
  'Users Management': 'Gerenciamento dos Usuários',
  'Manage Users': 'Gerenciar Usuários',
  'Create new user': 'Criar novo usuário',
  'User must be assigned to at least one station': 'O usuário deve ser atribuído a pelo menos uma estação',
  'User created successfully': 'Usuário criado com sucesso',
  'User creation failed, please contact support for further information':
    'Falha na criação de usuário, entre em contato com o suporte para mais informações',
  'You are about to delete this user completely. Are you sure?':
    'Você está prestes a excluir este usuário por completo. Tem certeza?',
  'Delete user': 'Excluir usuário',
  'Changes will not be saved. Are you sure?': 'As alterações não serão salvas. Tem certeza?',
  'Discard changes': 'Descartar alterações',
  'First name': 'Primeiro nome',
  'Please input your first name': 'Insira seu primeiro nome',
  'Last name': 'Sobrenome',
  'Please input your last name': 'Insira seu sobrenome',
  Email: 'E-mail',
  'Please input your email': 'Insira seu e-mail',
  'Please input a valid email address': 'Insira um endereço de e-mail válido',
  'Measurement system': 'Sistema de medidas',
  'Please choose your measurement system': 'Escolha seu sistema de medidas',
  'Dial code': 'Código de discagem',
  'Please input your dial code': 'Insira seu código de discagem',
  Number: 'Número',
  'Please input your number': 'Insira seu número',
  '9 or 10 digits are allowed': '9 ou 10 dígitos são permitidos',
  'Only numbers are allowed!': 'Apenas números são permitidos!',
  'Please choose a station': 'Escolha uma estação',
  'Please choose a role': 'Escolha um cargo',
  'You are about to remove this user’s access to this station. Are you sure?':
    'Você está prestes a remover o acesso deste usuário a esta estação. Tem certeza?',
  'E.g. John': 'Ex. John',
  'E.g. Doe': 'Ex. Doe',
  'John@domain.com': 'John@domain.com',
  'Select measurement system': 'Selecione o sistema de medidas',
  '+001': '+001',
  '000000000': '+000000000',
  'Select station': 'Selecione a estação',
  'Select role': 'Selecione o cargo',

  // EULA
  'License Agreement': 'Contrato de Licença',
  Decline: 'Recusar',
  Accept: 'Aceitar',

  // Water Temperature
  WATER_TEMPERATURE: 'Temperatura da Água',
  IN: 'Entrada',
  OUT: 'Saída',

  // Metrics
  PRESSURE: 'Pressão',
  FLOW: 'Vazão',
  WATER_FLOW: 'Vazão Hídrica',
  WATER_PRESSURE_IN: 'Pressão de Entrada da Água',
  WATER_PRESSURE_OUT: 'Pressão de Saída da Água',
  WATER_PRESSURE_DELTA: 'Diferença de Pressão Hídrica',
  EST_FLOW: 'est. Vazão',
  POWER: 'Potência',
  TEMPERATURE: 'Temperatura',
  AIR_TEMPERATURE: 'Temperatura do ar',
  AIR_TEMPERATURE_SENSOR: 'Sensor de temperatura do ar',
  DEW_POINT_TEMPERATURE: 'Temperatura do ponto de orvalho',
  INLET_WATER_TEMPERATURE: 'Temperatura de entrada da água',
  OUTLET_WATER_TEMPERATURE: 'Temperatura de saída da água',
  CURRENT: 'Corrente',
  OIL_TEMPERATURE: 'Temperatura de óleo',
  INVERTER_SPEED: 'Velocidade do inversor',
  RUN_HOURS: 'Horas de operação',
  LOAD_HOURS: 'Horas de carga',
  HUMIDITY: 'Umidade',
  CONTROL_MODE: 'Modo de controle',
  MINIMUM_PRESSURE: 'Pressão mínima',
  MAXIMUM_PRESSURE: 'Pressão máxima',
  NEXT_SERVICE_HOURS: 'Horários do próximo serviço',
  NEXT_SERVICE_NAME: 'Nome do próximo serviço',
  ACTIVITY: 'Atividade',
  SPECIFIC_POWER: 'Potência específica',
  EST_SPECIFIC_POWER: 'est. Potência específica',
  EST_INVERTER_SPEED: 'est. Velocidade do Inversor',
  POWERED_ON: 'Ligado',
  INLET_VALVE_OPENING: 'Abertura da Válvula de Entrada',
  BYPASS_VALVE_OPENING: 'Abertura da Válvula de Desvio',
  CENTRIFUGAL_TARGET_SETPOINT: 'Ponto de ajuste de Referência Centrífuga',
  OPERATION_MODE: 'Modo de Operação',
  DRYER_FILTER_SERVICE_HOURS: 'Horas de Serviço do Filtro do Secador',
  DRYER_DESICCANT_SERVICE_HOURS: 'Horas de Serviço do Dessecante do Secador',
  DRYER_VALVE_SERVICE_HOURS: 'Horas de Serviço da Válvula do Secador',
  DRYER_LEFT_TOWER_ACTIVITY: 'Atividade da Torre Esquerda do Secador',
  DRYER_RIGHT_TOWER_ACTIVITY: 'Atividade da Torre Direita do Secador',
  DRYER_BLOWER_ACTIVITY: 'Atividade do Ventilador do Secador',
  DRYER_HEATER_ACTIVITY: 'Atividade do Aquecedor do Secador',
  DRYER_TEMPERATURE_SETPOINT_CELSIUS: 'Ponto de Ajuste em Celsius da Temperatura do Secador',
  DRYER_OPERATION_MODE: 'Modo de Operação do Secador',
  DRYER_EXTENDED_ACTIVITY: 'Atividade Estendida do Secador',
  EXTERIOR_AMBIENT_TEMPERATURE: 'Temperatura Ambiente Exterior',
  FREQUENCY: 'Frequência',
  P_H: 'PH',
  AMMONIA_AMMONIUM: 'Amônia (NH3)/Amônio (NH4+)',
  NITRATE_NO_3: 'Nitrato (NO3-)',
  NITRITE_NO_2: 'NitrIto (NO2-)',
  OXIDATION_REDUCTION_POTENTIAL: 'Potencial de redução do Oxigênio',
  DISSOLVED_OXYGEN: 'Oxigênio Dissolvido',
  BLOWER_SPEED: 'Velocidade do Ventilador',
  BLOWER_TARGET_SPEED: 'Velocidade de Referência do Ventilador',
  INFLUENT_FLOW: 'Vazão afluente',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT: 'Ponto de Ajuste de Limite Inferior de HP da Válvula de Alívio',
  SPILL_VALVE_HIGH_PRESSURE: 'Válvula de Alívio de Alta Pressão',
  SPILL_VALVE_LOW_PRESSURE: 'Válvula de Alívio de Baixa Pressão',
  SPILL_VALVE_LP_TARGET_SETPOINT: 'Ponto de ajuste de Referência LP da Válvula de Alívio',
  CURRENT_VALVE_POSITION: 'Posição Atual da Válvula',

  COMMAND_WAITING_FOR_DELIVER: 'Aguardando Para Entregar',
  COMMAND_RECEIVED_AND_UPDATED: 'Recebido E Atualizado',
  COMMAND_FAILED_TO_UPDATE: 'Falha Ao Atualizar',
  COMMAND_FAILED_TIME_OUT: 'Falha de Tempo Excedido',
  COMMAND_FAILED_OFFLINE: 'Falha Offline',
  COMMAND_IGNORED_UNCHANGED_VALUE: 'Valor Não Alterado Ignorado',

  'Ambient Temperature': 'Temperatura Ambiente',
  'Ambient Humidity': 'Umidade Ambiente',

  'Failed retrieving commands history': 'Falha ao recuperar histórico de comandos',
  alpha: 'Alfa',
  beta: 'Beta',
  powerUsersOnly: 'Apenas usuários avançados',
  allowCookies: 'Permitir cookies',
  decline: 'Recusar',

  general: 'Geral',
  true: 'Verdadeiro',
  false: 'Falso',
  'Clear all engine configurations': 'Limpar todas as configurações de motor',
  'Engine ready': 'Motor pronto',
  yes: 'Sim',
  'Are you sure you want to delete all data?': 'Tem certeza que deseja excluir todos os dados?',

  energySavingsReportTitle: 'Relatório EcoPlant 360',
  energySavingsReportDescription:
    'Abaixo estão as economias de Energia geradas pelo Controlador Dinâmico Ecoplant. ' +
    'Estão apresentadas em diferentes resoluções de tempo, Economias de Dia Anterior, MTD, YTD e ' +
    'Vida útil. Estão apresentadas em (1) Porcentagem (%) (e em kWh) (2) na corrente local (3) Toneladas Métricas Estimadas ' +
    'de redução de GEE. As economias são calculadas com base na comparação com o período base e sua ' +
    'potência específica (S/P).',

  insightsReportDescriptionOne:
    'O Ecoplant 360 oferece aos seus usuários um insight contínuo, impulsionado pelo nosso sistema ou por nossos especialistas que monitoram ' +
    'o sistema. Esses insights são divididos em três categorias: Energia, Manutenção e Risco. Todos os insights teriam ' +
    'uma indicação de Ação, Ação Pendente ou Ação Tomada. Mostrando a quantia estimada de USD correspondente.',
  insightsReportDescriptionTwo:
    'Para qualquer Ação Pendente, clique no insight correspondente para as seguintes ações necessárias. Para qualquer esclarecimento ' +
    'e detalhes técnicos, entre em contato com seu gestor de sucesso do cliente.',
  insightsReportDescriptionThree: 'A inscrição para insights ao vivo pode ser concluída no painel do Ecoplant 360',

  leakageReportDescription:
    'A Ecoplant 360 oferece a seus usuários uma visão geral do vazamento estimado. ' +
    'Para garantir uma atualização na leitura de vazamento, adicione no painel de valores o seu próximo desligamento programado de produção. ' +
    'Durante o período de desligamento e para medir o vazamento, o compressor deve ser mantido ligado por algumas ' +
    'horas, assim o sistema pode medir o consumo pelos vazamentos do sistema.',

  openInsightsReportDescriptionOne:
    'Abaixo está uma lista de todos os insights abertos, mostrando tanto itens de Ação Pendente como itens Em Andamento.',
  openInsightsReportDescriptionTwo:
    'Para mais esclarecimentos e análises, entre em contato com seu representante de sucesso do cliente.',
  openInsightsReportFooterText:
    'No painel de valor da Ecoplant 360, você poderá explorar detalhes de insight adicionais.',

  //LIGHT Project
  enableSystemControl: 'Habilitar Sistema de Controle',
  isCalculated: '{{metric}} é calculado.',
  FlowUpper: 'Vazão',
  PowerUpper: 'Potência',
  toRecord: ' Para registrar seu sistema {{field}} com precisão, ',
  performance: 'desempenho',
  AddNewCompressor: 'Adicionar um Novo Compressor',
  performanceKpisCalculated: 'Os KPIs de desempenho são calculados.',
  learnMoreIncreaseSavingsNum: 'Saiba mais e aumente as economias com #{{num}} sistema adicional de insights',
  learnMoreIncreaseSavings: 'Saiba mais e aumente as economias com sistema adicional de insights',
  learnMoreRecord: 'Saiba mais e registre seu desempenho com precisão',
  clickHere: 'Clique aqui',
  expandYourStation: 'Expanda sua estação e tenha uma visão geral ampla de todos os componentes relevantes',
  addCompressor: 'Para adicionar um compressor, ',
  Integration: 'Integração',
  externalDeviceId: 'Id Externo',
  startIntegrationProcess: ' e iniciar o processo de integração',
  getSensorPackage: ' e obter o pacote correto de sensor.',
  toRecordPerformance: '  Para registrar seu desempenho com precisão, ',
  alwaysPerform: ' e sempre operar no modo de funcionamento ideal graças ao controle automático do sistema.',
  calculatedValues: 'Valores calculados',
  learnMoreAndEnableSystemControl: 'Saiba Mais e Habilite o Sistema de Controle',
  learnMoreAndEnableKPIs: 'Saiba mais e ative o KNOW - SISTEMA para obter seus KPIs individuais de desempenho',
  learnMoreAndEnableLeakage: 'Saiba Mais e Habilite o Vazamento',
  energySavingsSystemTierTooltipPart1:
    'Oportunidades de economia de energia previstas com base em estudos de caso reais. Para sempre operar em um modo de operação ideal e obter essas economias, ',
  energySavingsSystemTierTooltipPart2: ' e adicionar Controle de Sistema.',
  requestTierConfirmationMessageLine1: 'Uma mensagem foi enviada à Ecoplant.',
  requestTierConfirmationMessageLine2: 'Entraremos em contato em breve',
  backgroundDataYearlyView: 'Os dados de base são exemplos do balanço energético anual, incluindo as economias.',
  backgroundDataLeakage: 'Os dados de base são exemplos do indicador de Vazamento.',
  additionalSensors: 'Sensores Adicionais',
  addPressureSensorPack:
    ' e adicione um pacote de sensores de pressão para acessar as condições de pressão do sistema e o vazamento',
  addStationKpis: ' e obter sua estação de KPIs completa. Clique aqui e habilite a visualização do sistema',
  addIndividualSensors: ' e adicione sensores individuais para acessar sua condição de operação do sistema',
  system: 'Sistema',
  flowIsCalculated: 'A vazão foi calculada.',
  learnMoreAndEnableSystemHealth: 'Saiba Mais e Habilite o Sistema de Saúde',
  lockedFunctionality: 'Funcionalidade Bloqueada',
  backgroundDataSystemHealth: 'Os dados de base são exemplos do indicador do Sistema de Saúde.',
  systemView: 'KNOW - SISTEMA',
  systemViewDescription:
    'Desbloqueie uma supervisão abrangente do desempenho do seu sistema por meio de um Mapa P&ID individual, Tendências do Sistema, Monitoramento de Riscos do Sistema e insights adicionais para melhorar o desempenho e a saúde geral do seu sistema.',
  learnMoreAndWatchVideo: 'Saiba Mais e Assista ao Vídeo',
  assetCount: '{{assetCount}} Compressores',
  mon: 'mon',
  perAsset: 'por compressor',
  billedAnnually: 'Cobrado anualmente ou ',
  monthly: ' mensalmente',
  expectedAnnualSavings: 'Economia Anual Esperada',
  expectedROI: 'ROI Esperado',
  years: '< {{years}} Anos',
  startOneMonthTrial: 'Inicie um teste de um mês',
  orPurchaseNow: 'ou compre agora',
  allAssetViewFeatures: 'Todos os recursos KNOW - ATIVO, mais:',
  individual: 'Individual',
  pidMap: 'Mapa de P&ID',
  monitorAndSupervise:
    'para monitorar e supervisionar o desempenho do seu sistema inteiro e instantaneamente identificar componentes críticos.',
  systemHealthStatus: 'Status da Saúde do Sistema',
  isPartOf: 'é parte do Painel de Valores, que monitora seu sistema e nível de risco de produção em tempo real.',
  systemInsights: 'Insights do sistema',
  improveSystemPerformance:
    'sobre Energia, Manutenção e Risco melhoram o desempenho e saúde do sistema e reduz custos operacionais.',
  derivedSystemEfficiencyParameters: 'Parâmetros Derivados de Eficiência do Sistema',
  suchAs: 'como pressão, vazão, potência e potência específica do sistema;',
  systemTrends: 'Tendências do Sistema',
  toAnalyzeAndOptimize: ' para analisar e otimizar o desempenho do seu sistema baseado em dados históricos.',
  backgroundDataMap: 'O P&ID de base representa um exemplo do Mapa do Sistema',
  backgroundData: 'Os dados de base são exemplos',
  simpleControlDescription:
    'Com o motor de controle simples, você melhora a eficiência geral e a utilização do seu sistema, além de reduzir o tempo de operação dos compressores de backup e de aluguel. Isso ajuda você a reduzir consideravelmente os custos de energia do seu sistema.',
  dynamicControlDescription:
    'Desbloqueie o motor de controle dinâmico completo para analisar e ajustar automaticamente a operação de acordo com as necessidades de produção, visando a máxima eficiência do sistema. Além disso, você pode detectar e isolar vazamentos de ar para melhorar ainda mais a eficiência e reduzir os custos totais de energia ao mínimo.',
  simpleControl: 'CONTROLE',
  allSystemViewFeatures: 'Todos os recursos KNOW - SISTEMA, mais:',
  simpleControlEngine: 'Motor de Controle Simples',
  toContinouslyOptimize: 'para otimizar continuamente a eficiência do sistema e a utilização do compressor',
  energySavingsWidget: 'Indicador de Economia de Energia',
  toProvideComprehensiveOverview:
    'para fornecer uma visão geral ampla da economia total de energia (por dia, mês, ano &amp; total) com base na eficiência otimizada do sistema comparada com a sua operação inicial',
  greenhouseGasEmission: 'Redução da Emissão de Gases do Efeito Estufa',
  savingsBasedOn: 'com base na eficiência otimizada do sistema',
  allSimpleControlFeatures: 'Todos os recursos de CONTROLE, mais',
  dynamicControlEngine: 'Motor de Controle Dinâmico',
  predictiveAlgorithms:
    'Algoritmos preditivos avaliam o seu uso de energia diário, semanal e sazonal - controlando dinamicamente os sistemas por meio de perfis de produção para minimizar o desperdício de energia, redundâncias e custos excessivos com utilidades.',
  leakageWidget: 'Indicador de Vazamento',
  forDetectingAndIsolating: 'detectar e isolar os locais de vazamentos reduz significativamente as perdas de energia.',
  continuousAutiding: 'Auditoria Contínua ',
  reviewYourSystemPerformance: 'Analise o desempenho e o nível de saúde do seu sistema',
  getYourPrice: 'Obtenha seu preço',
  systemControl: 'Sistema de Controle',
  learnMoreAndRequestTrial: 'SAIBA MAIS E SOLICITE UM TESTE',
  ecoplantOffering: 'Oferta Ecoplant',
  addOns: 'Add-Ons',
  yourCurrentVersion: 'Sua Versão Atual',
  noStationsAvailable: 'Nenhuma estação disponível',
  language: 'Idioma',
  selectLanguage: 'Selecionar idioma',
  english: 'Inglês',
  french: 'Francês',
  german: 'Alemão',
  Station: 'Estação',
  Role: 'Cargo',
  SMS: 'SMS',
  Insight: 'Insight',
  Weekly: 'Semanalmente',
  Monthly: 'Mensalmente',
  Avg: 'Méd',
  kWh: 'kWh',
  leakMeasurement: 'Medição de Vazamento',
  valueDashboard: 'Painel de Valor',
  userName: 'Nome de usuário',
  phoneNumber: 'Número de telefone',
  'MT GHG': 'MT GEE',
  forMoreThan: 'para mais que',
  userAssociatedStations: 'Estações associadas ao usuário',
  'Min / Max': 'Mín/Máx',
  simulationValue: '(Valor de simulação)',
  actualValue: '(Valor real)',
  Operation: 'Operação',
  Unselect: 'Desselecionar',
  'Manufacturer and Custom Alerts with Shutdown Severity':
    'Alertas do Fabricante e Personalizados com Gravidade de Desligamento',
  'Manufacturer and Custom Alerts with Warning Severity':
    'Alertas do Fabricante e Personalizados com Gravidade de Aviso',
  'Manufacturer and Custom Alerts with Service Severity':
    'Alertas do Fabricante e Personalizados com Gravidade de Serviço',
  'Notifies on Periodic Shutdown event creation, 1 day before the event':
    'Notifica na criação do evento de Desligamento Periódico, 1 dia antes do evento',
  'Notifies when a new Insight Event is created': 'Notifica quando um Evento de Insight é criado',
  'Notifies when the Dynamic Controller is turned On or Off':
    'Notifica quando o Controlador Dinâmico é Ligado ou Desligado',
  "Notifies when a Device's Maintenance flag is changed":
    'Notifica quando a bandeira de Manutenção de um Dispositivo é alterada',
  'Notifies when a Report is generated': 'Notifica quando um Relatório é gerado',
  'Notifies when a Station is switched On or Off': 'Notifica quando uma Estação é Ligada ou Desligada',
  "couldn't fetch data": 'Não foi possível buscar os dados',
  'User update failed': 'Atualização de usuário falhou',
  'User deletion failed': 'Exclusão de usuário falhou',
  'User updated successfully': 'Usuário atualizado com sucesso',
  'User deleted successfully': 'Usuário excluído com sucesso',
  Refresh: 'Atualizar',
  'Activity Log': 'Registro de Atividade',
  Compressors: 'Compressores',
  'Learn More And Enable Leakage': 'Saiba Mais e Habilite o Vazamento',
  'Background Data Leakage': 'Vazamento de Dados Base',
  'Sign in': 'Cadastre-se',
  OR: 'OU',
  'Login with SSO': 'Faça login com SSO',
  'is Activated': 'está Ativado',
  'is Deactivated': 'está Desativado',
  'is Disabled - Under Maintenance': 'está Desabilitado - Sob Manutenção',
  'is Disabled by Local Control Switch': 'está Desabilitado pelo Interruptor de Controle Local',
  'is Disabled by Cloud Control Switch': 'está Desabilitado pelo Interruptor de Controle da Nuvem',
  'IN MAINTENANCE': 'EM MANUTENÇÃO',
  EnergySavings: 'Economias de Energia',
  'LIFE TIME SAVINGS': 'ECONOMIAS DE VIDA ÚTIL',
  'Unarchive Alert': 'Desarquivar Alerta',
  'archive alert failed': 'Falha ao arquivar alerta',
  'Select All': 'Selecionar Todos',
  'Archive Selected Alerts': 'Arquivar Alertas Selecionados',
  'Restore default': 'Restaurar padrão',
  'Devices Names': 'Nomes dos Dispositivos',
  Close: 'Fechar',
  Activity: 'Atividade',
  'Value may depend on multiple sensors.': 'Valor pode depender de múltiplos sensores.',
  Minutes: 'Minutos',
  'kW based Calculation': 'Cálculo baseado em kW',
  'Target Setpoint': 'Ponto de ajuste Alvo',
  'PRESSURE SET POINTS': 'PONTOS DE AJUSTE DE PRESSÃO',
  'Water Temperature': 'Temperatura da Água',
  'Set point': 'Ponto de ajuste',
  'DEW POINT': 'PONTO DE ORVALHO',
  'NEXT SERVICE': 'PRÓXIMO SERVIÇO',
  ACTIVTY: 'ATIVIDADE',
  'In maintenance': 'Em manutenção',
  'Device Details': 'Detalhes do Dispositivo',
  'This feature is currently disabled.': 'Este recurso está atualmente desabilitado.',
  Revert: 'Reverter',
  'Open Insights': 'Abrir Insights',
  'Sign in without Single Sign On': 'Entrar sem Login Único',
  'CO2 Reduction': 'Redução de CO2',
  'Filter by rule': 'Filtrar por regra',
  Target: 'Referência',
  'Compressor Type': 'Tipo de Compressor',
  'Not Connected': 'Não Conectado',
  'Keep Alive': 'Manter Ativo',
  '9 to 13 digits are allowed': '9 a 13 dígitos são permitidos',
  Notifications: 'Notificações',
  'Station Switch': 'Trocar Estação',
  'Yearly View': 'Visualização Anual',
  Jan: 'Jan',
  Feb: 'Fev',
  Mar: 'Mar',
  Apr: 'Abr',
  May: 'Mai',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Ago',
  Sep: 'Set',
  Oct: 'Out',
  Nov: 'Nov',
  Dec: 'Dez',
  Search: 'Buscar',
  influentFlow: 'Vazão Afluente',
  dissolvedOxygen: 'Oxigênio Dissolvido',
  pH: 'pH',
  ammoniaAmmonium: 'Amônia (NH3)/Amônio (NH4+)',
  nitrate: 'Nitrato (NO3-)',
  nitrite: 'NitrIto (NO2-)',
  oxidationReductionPotential: 'Potencial de Óxido-Redução',
  influentFlowSensor: '$t(Fluxoafluente) Sensor',
  dissolvedOxygenSensor: '$t(Oxigêniodissolvido) Sensor',
  phSensor: '$t(pH) Sensor',
  ammoniaAmmoniumSensor: '$t(amôniaAmônio) Sensor',
  nitrateNO3Sensor: '$t(nitrato) Sensor',
  nitriteNO2Sensor: '$t(nitrito) Sensor',
  oxidationReductionPotentialSensor: '$t(PotencialdeóxidoRedução) Sensor',
  'm3/hour': 'm<0>3</0>/hora',
  GPM: 'GPM',
  blowerSpeed: 'Velocidade do Ventilador % (RPM)',
  frequency: 'Frequência',
  Hz: 'Hz',
  blower: 'Ventilador',
  aerationBasin: 'Tanque de Aeração',
  'kWh/MG': 'kWh/MG',

  // Station Parameters Tab
  validationForGreaterThan: '{{title}} deve ser maior que {{min}} {{unit}}.',
  validationForMinTargetLessThanMaxTarget: 'Referência mín deve ser menor que referência máx.',
  validationForMinMax: '{{title}} deve estar entre {{min}} e {{max}} {{unit}}.',
  targetPressure: 'Pressão de Referência',
  offsetFromTargetPressure: 'Faixa morta em relação à pressão de referência na qual equilibrar a carga',
  pressureForReloadingCompressor: 'Pressão para Recarregar um Compressor',
  pressureForStartingCompressor: 'Pressão para Iniciar um Compressor',
  pressureForEmergencyStart: 'Pressão para partida de emergência de um compressor',
  minLoadedCompressors: 'Número mínimo de compressores carregados',
  pressureFactor: 'Deslocamento de pressão no teste de descarga',
  minFrequency: 'Atraso na tentativa de descarga',
  minPressureSafetyMargin: 'Margem mínima de segurança de pressão',
  minCompressorStartInterval: 'Intervalo mínimo para início do compressor',
  minCompressorRestartInterval: 'Intervalo mínimo para reinício do compressor',
  flowPeakBuffer: 'Buffer de pico de vazão',
  minIntervalHighFlowTrigger: 'Intervalo mínimo a partir do acionamento de fluxo elevado',
  setpointChangeInterval: 'Frequência do deslocamento no teste de descarga',
  kpiIntervalRetrieval: 'Intervalo de KPI para recuperação',
  loadBalancingPressureFactor: 'Deslocamento de pressão para balanceamento de carga',
  emergencyStartFrequency: 'Frequência de Início de Emergência',
  bovMin: 'Valor médio mínimo da válvula BOV para o teste de descarga',
  bovMax: 'Limite da válvula BOV para descarregar durante o teste',
  fullLoadPressureBuffer: 'Buffer de pressão em carga completa',
  unloadTestingFlowBufferPercentage: 'Porcentagem do buffer de fluxo de teste de descarga',
  required: 'Necessário',
  errorSavingEngineConfig: 'Erro ao salvar as configurações do motor Tente novamente mais tarde.',
  maxTarget: 'Referência máx',
  minTarget: 'Referência mín',
  priority: 'Prioridade',
  timeBetweenUnoadingStop: 'Tempo entre descarregar e parar (min.)',
  viewReport: 'Visualizar Relatório',
  searchStation: 'Buscar estação',
  'Nothing to update. No changes were made to the information':
    'Nada a atualizar. Nenhuma alteração foi feita nas informações',
  comments: 'Comentários:',
  provideReason: 'Forneça um motivo.',
  problematicFlowLevels: 'Níveis de Vazão Problemáticos',
  probabilityofreducingstationpressurebelowminimum: 'Probabilidade de reduzir a pressão da estação abaixo do mínimo.',
  probabilityofreducingsavingsbelowthecommitment: 'Probabilidade de reduzir a economia abaixo do compromisso.',
  probabilityofharmingcompressorshealth: 'Probabilidade de prejudicar a saúde do compressor - selecione o compressor.',
  probabilityofincreasingstationpressure: 'Probabilidade de aumentar a pressão da estação.',
  edgecasenotproperlycovered: 'Os casos extremos não estão devidamente cobertos.',
  problematicPressureRanges: 'Faixas de Pressão Problemáticas',
  compressorRapidCycling: 'Ciclagem Rápida do Compressor',
  problematicSetpointsForCompressor: 'Pontes de Ajuste Problemáticos para o Compressor',
  probabilityOfStationHighPressureValues: 'Probabilidade de Valores de Alta Pressão da Estação',
  extremeUsecasesAreNotProperlyCovered: 'Casos de uso extremos não são adequadamente abordados',
  refreshEngine: 'Se você atualizou a versão do motor, atualize a página para editar parâmetros',
  compressorSetpointsOrderInfo:
    'Os pontos de ajuste do compressor em cada tabela devem refletir a ordem atribuída na coluna OR.',
  viewOnly: 'Modo Somente Visualização (motor 1.0)',
  changeEngineVersion: 'Altere para 1.5 para gerenciar',
  publishConfirmation: 'Todas as configurações nas abas serão publicadas. Confirme para prosseguir.',
  publishedOn: 'Publicado em ',
  draftPublishedOn: 'Rascunho publicado em ',
  incompleteStationParameters: 'Parâmetros da Estação Incompletos',
  incompleteCompressorParameters: 'Parâmetros do Compressor Incompletos',
  compressorParametersMissing: 'Alguns dos parâmetros do compressor estão faltando.',
  stationParametersMissing: 'Alguns dos parâmetros da estação estão faltando.',
  errorSavingDraft: 'Erro ao salvar rascunho.',
  errorSavingDraftdesc: 'Preencha todos os campos necessários para estação e compressores.',
  success: 'bem sucedido',
  error: 'erro',
  draftSaved: 'Rascunho salvo com sucesso.',
  draftSavedDesc: 'Suas alterações foram salvas. Lembre de publicar quando estiver pronto.',
  errorSavingChanges: 'Houve um erro ao salvar suas alterações.',
  errorRevertLastPublished: 'Erro ao Reverter para o Último Publicado',
  errorRevertLastPublishedDesc: 'Houve um erro ao reverter para a última versão publicada.',
  successPublish: 'Alterações Publicadas com Sucesso',
  successPublishDesc: 'O controlador dinâmico agora está sendo executado com os parâmetros publicados.',
  errorDraftPublish: 'Erro ao Publicar Rascunho',
  errorDraftPublishDesc: 'Houve um erro ao publicar suas alterações.',
  publishChanges: 'Publicar Alterações',
  revertToLastPublished: 'Reverter para Último Publicado',
  confirmPublish: 'Confirmar Publicação das Alterações',
  publishChange: 'Publicar Alteração',
  reviewAgain: 'Analisar Novamente',
  advancedSettings: 'Configurações Avançadas',
  stopDelayMinutes: 'Minutos de Atraso para Parada',
  maxFlow: 'Vazão Máx',
  maxLoadAmps: 'Corrente Máx de Carga',
  fiveLoop: '5 Loop',
  noBaseline: 'Nenhuma Base',
  noDefaultBaselineStrategy: 'Nenhuma estratégia de base padrão disponível no momento',
  revertToDefaultBaselineStrategy:
    'Tem certeza que deseja substituir os rascunhos existentes com as configurações de base padrão?',

  // Station Stages
  stationStageUpdating: 'Atualizando estágio...',
  stationStageUpdated: 'Estágio atualizada com sucesso',
  stationStageError: 'Falha ao atualizar estágio. Tente novamente.',
  stationStageNoStageSelected: 'Nenhum estágio selecionado',
  stationStageState: 'Estado',
  stationStageMoveTo: 'Mudar para',
  stationStageStatus: 'Status da Estação',
  stationStageDeprecateTitle: 'Descontinuar Estação',
  stationStageDeprecateWarning:
    'Você está prestes a mudar esta estação para um status de descontinuada. Essa ação vai:',
  stationStageDeprecateConsequences1: 'Desabilitar todos os controles do sistema para a estação.',
  stationStageDeprecateConsequences2: 'Evitar coleta de dados e atualizações adicionais.',
  stationStageDeprecateConsequences3: 'Arquivar a estação para referência histórica.',
  stationStageDeprecateConfirm: 'Tem certeza que deseja prosseguir? Esta ação não pode ser desfeita.',
  stationStageDeprecateButton: 'Descontinuar Estação',
  stationStageCancelButton: 'Cancelar',
  //installtion validation tab
  INSTALLATION_VALIDATION_TITLE: 'Validação da Instalação',
  INSTALLATION_VALIDATION_SUBMITTED_TITLE: 'Validação já enviada',
  INSTALLATION_VALIDATION_SUBMITTED_CONTENT:
    'Outro usuário já enviou essa validação. Atualize a página para ver o status atual.',
  INSTALLATION_VALIDATION_IN_PROGRESS_TITLE: 'Validação em andamento',
  INSTALLATION_VALIDATION_IN_PROGRESS_CONTENT:
    'Outro usuário já iniciou essa validação. Atualize a página para ver o status atual.',
  NOT_AVAILABLE: 'N/A',
  TESTING_IN_PROGRESS: 'Teste em andamento {{time}}',
  UNRESOLVED_COMPRESSORS_TITLE: 'Estados de Compressor Não Resolvidos',
  UNRESOLVED_COMPRESSORS_DESC:
    '{{count}} compressores não passaram no teste. Forneça um comentário ou motivo para cada antes de enviar o relatório',
  TEST_SUCCESS_TITLE: 'Teste concluído com sucesso',
  TEST_SUCCESS_DESC: 'Todos os estados de compressores passaram no teste com sucesso.',
  REPORT_SUBMIT_SUCCESS: 'Relatório enviado com sucesso',
  REPORT_SUBMIT_ERROR: 'Falha ao enviar relatório',
  TEST_NOT_INITIATED_TITLE: 'O teste não foi iniciado adequadamente',
  TEST_NOT_INITIATED_DESC: 'O teste não foi iniciado adequadamente. Reinicie o teste.',
  LOAD_TEST: 'Carregar teste',
  UNLOAD_TEST: 'Descarregar teste',
  PASSED: 'Passou',
  FAILED: 'Falhou',
  TESTING: 'Testando...',
  NOT_TESTED: 'Não testado',
  NOT_STARTED: '',
  VIEW_COMMENT: 'Visualizar comentário',
  ADD_COMMENT: 'Adicionar comentário',
  NO_POWER_SENSOR: 'Nenhum sensor de potência',
  UNRESOLVED_COMPRESSORS_MESSAGE:
    ' compressores não passaram no teste. Forneça um comentário ou motivo para cada antes de enviar o relatório',
  SUBMIT_CONFIRMATION_MESSAGE:
    'Ao enviar o relatório de teste, você indica que a instalação está concluída e pronta para análise',
  BACK_TO_LIST: 'Voltar para lista',
  TEST_AGAIN: 'Testar novamente',
  SUBMIT_REPORT: 'Enviar relatório',
  CANCEL: 'Cancelar',
  'Flow sum': 'Soma de vazão ',
  unresolvedCompressorStates: 'Estados de Compressor Não Resolvidos',
  confirmSubmission: 'Confirmar envio',
  testCompletedSuccessfully: 'Teste concluído com sucesso',
  commentsInfo: 'Comentários apenas serão salvos no relatório enviado.',
  comment: 'Comentário',
  loadTestFailed: 'Teste de carga falhou',
  unloadTestFailed: 'Teste de descarga falhou',
  loadTestNotTested: 'Teste de carga não foi realizado',
  unloadTestNotTested: 'Teste de descarga não foi realizado',
  okCamelCase: 'Ok',
  flowTestFailed: 'Teste de vazão falhou',
  flowTestNotTested: 'Teste de vazão não foi realizado',
  START_TEST: 'Iniciar Teste',
  END_TEST: 'Finalizar Teste',
  TEST_DATE: 'Data do teste: {{date}}',
  SAVE_CHANGES: 'Salvar alterações',
  ADD: 'Adicionar',
  compressorMetrics: 'Métricas do compressor',
  noMetricsAvailable: 'Nenhuma métrica disponível',
  loadBand1: 'Carregar Banda 1',
  loadBand2: 'Carregar Banda 2',
  unloadBand1: 'Descarregar Banda 1',
  unloadBand2: 'Descarregar Banda 2',
  sensorsKPIConfiguration: 'Configuração de KPI de Sensores',
  flowSensorKPI: 'KPI de Sensor de Vazão',
  pressureSensorKPI: 'KPI de Sensor de Pressão',
  moreActions: 'Mais Ações',
  StationStatus_Inactive: 'Controlador Dinâmico está Inativado',
  StationStatus_oneDotZeroActive: 'Controlador Dinâmico 1.0 está Ativado',
  StationStatus_oneDotFiveActive: 'Controlador Dinâmico 1.5 está Ativado',
  StationStatus_oneDotZeroUnderMaintenance: 'Controlador Dinâmico 1.0 está Desabilitado - Sob Manutenção',
  StationStatus_oneDotFiveUnderMaintenance: 'Controlador Dinâmico 1.5 está Desabilitado - Sob Manutenção',
  StationStatus_oneDotFiveActiveFallback: 'Controlador Dinâmico 1.5 está Ativado',
  StationStatus_oneDotZeroDisabled: 'Controlador Dinâmico 1.0 está Desabilitado',
  StationStatus_oneDotFiveDisabled: 'Controlador Dinâmico 1.5 está Desabilitado',
  StationStatus_offline: 'Desconectado',
  theme: 'Tema',
  dark: 'Escuro',
  light: 'Claro',
  measurementSystem: 'Unidade de medida',
  en: 'Inglês',
  fr: 'Francês',
  de: 'Alemão',
  metric: 'Métrico',
  imperial: 'Imperial',
  SelectReason: 'Selecione um motivo',
  missingSpec: 'Falta especificação',
  stationControlDefaultSetpointsBaseline:
    'Você está prestes a desativar o Controlador Dinâmico da Ecoplant. A estação será revertida para os pontos de ajuste de referência. Por favor, confirme e informe o motivo da desativação.',
  stationControlDefaultSetpointsCustom:
    'Você está prestes a desativar o Controlador Dinâmico da Ecoplant. A estação será revertida para os pontos de ajuste personalizados. Por favor, confirme e informe o motivo da desativação.',
  deactivationContent:
    'Desativar o controlador dinâmico pode impactar as operações do sistema. Por favor, confirme e informe o motivo da desativação.',
  userUnitOfMeasure: 'Unidade de medida do usuário',
  // Engine Validation Modal
  engineValidationTitle: 'Validação do status do motor',
  engineValidationMessage:
    'Não é possível mover a estação do estado de Assinatura enquanto o status do mecanismo estiver ativo. Certifique-se de desativar o mecanismo antes de mover a estação.',
  flowlevels: 'Níveis de fluxo',
  pressureranges: 'Faixas de pressão',
  wrongcompressorcombinations: 'Combinação incorreta de compressores - Selecionar tabela',
  pressuredrop: 'Queda de pressão - Selecionar tabela',
  setpointsforcompressor: 'Pontos de ajuste para o compressor - selecionar compressor + selecionar tabela',
  fallbackcoverage: 'Cobertura de contingência',
  possiblecause: 'Causa possível:',
  selecttables: 'Selecionar tabelas',
  selectReasonError: 'Por favor, selecione um motivo para a rejeição',
  selectCauseError: 'Por favor, selecione uma causa possível para a rejeição',
  selectCompressorError: 'Por favor, selecione pelo menos um compressor para a razão',
  selectCompressorCauseError: 'Por favor, selecione pelo menos um compressor para a causa possível',
  selectTableError: 'Por favor, selecione pelo menos uma tabela',
  commentLengthError: 'O comentário deve conter entre 2 e 200 caracteres',
  causeCommentLengthError: 'O comentário da causa possível deve conter entre 2 e 200 caracteres',
  searchByNumber: 'Pesquisar por número',
  selectAtleastOneCompressor: 'Selecione pelo menos um compressor para falha de compressor.',
  flowKPIOrPressureKPI: 'KPI de fluxo ou KPI de pressão',
  compressorFailure: 'Falha do compressor',
  appliedFilters: 'Filtros aplicados',
  scenario: 'Cenário',
  scenarioName: 'Nome do cenário',
  selectScenario: 'Selecionar cenário',
  selectCompressors: 'Selecionar compressores',
  ignoreFallbackCompressors: 'Compressores excluídos da geração de cenários de contingência',
  ignoreFallbackCompressorsTooltip:
    'Os cenários de contingência são gerados apenas para um conjunto definido de compressores. Este conjunto é determinado pela interseção de:',
  ignoreFallbackCompressorsTooltipBullet1: 'Compressores atualmente disponíveis no sistema',
  ignoreFallbackCompressorsTooltipBullet2: 'Compressores não incluídos na lista de exclusão.',
  ignoreFallbackCompressorsTooltipNote:
    'Os compressores listados aqui são intencionalmente ignorados pela estratégia de contingência—por exemplo, porque são conhecidos por estarem desconectados ou porque nenhuma contingência é necessária se falharem.',
  saveScenario: 'Salvar',
  newFallbackScenario: 'Novo cenário de contingência',
  createACustomTable: 'Criar uma tabela personalizada',
  useExistingTable: 'Usar tabela existente',
  createANewFallbackScenario: 'Criar um novo cenário de contingência',
  pickOneToBuildOnEitherReuseAnExistingTableOrLetTheEngineSuggestASmartStartingPoint:
    'Escolha um para começar. Reutilize uma tabela existente ou deixe o motor sugerir um ponto de partida inteligente.',
  selectATableNumber: 'Selecionar um número de tabela',
  filterFailScenario: 'Filtrar cenário de falha',
  refineScenariosByKPIAndComponents: 'Refinar cenários por indicadores e componentes',
  validationError: 'Erro de validação',
  baseFallbackOnTable: 'Basear contingência na tabela',
  AND: 'E',
  scenarioBasedOn: 'Cenário baseado em',
  failureOf: 'Falha de',
  flowKPIOrPressureKPIFailure: 'Falha de KPI de fluxo ou KPI de pressão',
  newFallback: 'Novo cenário de contingência',
  currentlyActive: 'Atualmente ativo',
  view: 'Visualizar',
  removeScenario: 'Remover',
  updateScenario: 'Atualizar',
  firstApplyFiltersToDefineYourScenario: 'Aplique filtros primeiro para definir seu cenário',
  applyFiltersAndContinue: 'Aplicar filtros e continuar',
  fallbackScenarioSavedSuccessfully: 'Cenário de contingência salvo com sucesso',
  thisScenarioAlreadyExists: 'Este cenário já existe.',
  confirmSaveScenario:
    'Salvando cenário de contingência, será automaticamente atualizado o rascunho. Tem certeza que deseja salvar este cenário?',
  confirmUpdateScenario:
    'Atualizando cenário de contingência, será automaticamente atualizado o rascunho. Tem certeza que deseja atualizar este cenário?',
  confirmRemoveScenario:
    'Removendo cenário de contingência, será automaticamente atualizado o rascunho. Tem certeza que deseja remover este cenário?',
  fallbackScenario: 'Contingência',
  flowKPI: 'KPI de fluxo',
  pressureKPI: 'KPI de pressão',
  invalidScenario:
    'Cenário inválido como Falha do compressor, Falha de KPI de fluxo, e Falha de KPI de pressão não podem ser aplicados juntos.',
  set0ForACompressor: 'Definir 0 para um compressor {}',
  trimmer: 'aparador',
  setNegativeValueForCompressorsNotToBeIncluded: 'Definir um valor negativo para compressores {} a serem incluídos',
  not: 'não',
  setPositiveValueForCompressors: 'Definir valor positivo para compressores {}',
  base: 'base',
  orderIsRequired: 'Ordem é obrigatória',
  atLeastOneSetpointMustHavePositiveOrder: 'Pelo menos um ponto de ajuste deve ter uma ordem positiva',
  mixedStationNotSupported: 'O motor 1.5 atualmente não suporta estações mistas',
  'Add a link to document': 'Adicionar um link para o documento',
  'Add a link to presentation': 'Adicionar um link para a apresentação',
  'Add a link to report': 'Adicionar um link para o relatório',
  'Add link to SCC activity log screenshot': 'Adicionar link para captura de tela do log de atividades do SCC',
  'More than one tracking number can be added.': 'Mais de um número de rastreamento pode ser adicionado.',
  'More than one order number can be added.': 'Mais de um número de pedido pode ser adicionado.',
  'Engine version is set by engine expert': 'A versão do motor é definida pelo especialista em motores',
  Skip: 'Pular',

  // Report Tab Page
  reportDetails: 'Detalhes do relatório',
  dateCreated: 'Data de criação',
  createdBy: 'Criado por',
  status: 'Status',
  totalReports: 'Relatório',
  createNewReport: 'Criar novo relatório',
  searchByDateCreatorOrStatus: 'Pesquisar por data, criador ou status',
  inProgress: 'Em progresso',
  failed: 'Erro',
  inDraft: 'Rascunho',
  unknown: 'Desconhecido',
  failedToDownloadReportFile: 'Falha ao baixar o arquivo do relatório',
  downloadingFile: 'Baixando arquivo...',
  fileDownloaded: 'Arquivo baixado com sucesso',
  deleteReport: 'Excluir relatório',
  areYouSureYouWantToDeleteThisReport: 'Tem certeza que deseja excluir este relatório?',
  reportDeletedSuccessfully: 'Relatório excluído com sucesso',
  failedToDeleteReport: 'Falha ao excluir o relatório',
  failedToUploadReport: 'Falha ao fazer upload do relatório',
  reportUploadedSuccessfully: 'Relatório enviado com sucesso',
  anErrorOccurred: 'Ocorreu um erro',
  onlyPowerPointFilesAllowed: 'Apenas arquivos PowerPoint (.pptx, .ppt) são permitidos',
  pleaseSelectADateRange: 'Por favor, selecione um intervalo de datas',
  reportRequestedSuccessfully:
    'A geração do relatório pode levar até 15 minutos. Uma vez concluída, o status nesta tela mudará para Rascunho e as ações Editar e Publicar serão habilitadas.',
  failedToRequestReport: 'Falha ao solicitar relatório',
  selectDates: 'Selecionar datas',
  noteForReportGeneration:
    'Nota: A geração do relatório pode levar alguns minutos. Você será notificado por e-mail quando estiver completo.',
  reportTimeFrameUpTo2Weeks: 'O período do relatório pode ser de até 2 semanas.',
  generateReport: 'Solicitar relatório',
  reportPublishedSuccessfully: 'Relatório publicado com sucesso',
  reportPublishedInProgress:
    'A publicação do relatório pode levar alguns minutos. Uma vez concluída, o status nesta tela mudará para Publicado, a ação Visualizar será habilitada e o cliente poderá ver este relatório.',
  failedToPublishReport: 'Falha ao publicar o relatório',
  addBusinessImpactBeforePublishing: 'Adicionar impacto comercial antes de publicar',
  pleaseEstimateItsPotentialBusinessImpact:
    'Por favor, estime seu impacto comercial potencial. Isso ajuda a comunicar o valor do relatório ao seu cliente.',
  estimatedValue: 'Valor estimado ($)',
  valueIsRequiredAndMustBeHigherThan0ToPublish: 'O valor é obrigatório e deve ser maior que 0 para publicar',
  noteOncePublishedThisReportWillBeAutomaticallySharedWithAllRecipients:
    'Nota: Uma vez publicado, este relatório será automaticamente compartilhado com todos os destinatários.',
  publishReport: 'Publicar relatório',
  Upload: 'Enviar',
  Publish: 'Publicar',
  Edit: 'Editar',
  View: 'Visualizar',
  seeTheFullPictureOfYourReportPerformance: 'Veja o panorama completo do desempenho do seu relatório',
  createAToTrackAnalyzeAndSharePerformance: 'Crie um relatório para rastrear, analisar e compartilhar o desempenho',
  tryNewReport: 'Experimentar novo relatório',
  loadingReports: 'Carregando relatórios...',
  generatingReports: 'Gerando relatórios...',
  noReportsAvailable: 'Nenhum relatório disponível',
  sentForPublishing: 'Enviado para publicação',
  kpiChanges:
    'Uma nova estratégia de motor deve ser definida e publicada uma vez que a configuração de KPI dos sensores foi modificada. Por favor, revise as alterações e publique a configuração.',
  kpiChangesAndPIDChanges:
    'Uma nova estratégia de motor deve ser definida e publicada uma vez que a configuração da estação P&ID e os KPI dos sensores foi modificada. Abaixo está a lista de ativos que afetam a estratégia de controle:',
  dynamicControlInvalidStationStage:
    'O controle dinâmico não pode ser ativado, pois a estação não está na etapa de Inscrição/Preparação de controle.',
  fallbackScenarioForAllCompressorsFailureCannotBeDefined:
    'Não é possível definir um cenário de contingência para todas as falhas de compressores',
  loadingDocument: 'Carregando documento...',
};

export default pt;
